import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Box, Tab, Tabs, Typography} from '@mui/material';
import KeyIcon from '@mui/icons-material/Key';
import HubIcon from '@mui/icons-material/Hub';
import {useDocumentTitle} from 'Hooks/useDocumentTitle';
import ApiKeysList from './ApiKeysList';
import OidcClients from './OidcClients';

type TabKey = 'apiKeys' | 'oidc';

/**
 * Self-service developer integrations: personal API keys and OIDC clients.
 */
const ApiKeys: React.FC = () => {
    const {t} = useTranslation();
    useDocumentTitle('integrations.title');
    const [tab, setTab] = useState<TabKey>('apiKeys');

    return (
        <Box sx={{width: '100%', p: 2}}>
            <Box sx={{mb: 2}}>
                <Typography variant="h4" component="h1">{t('integrations.title')}</Typography>
                <Typography variant="body2" color="text.secondary">{t('integrations.subtitle')}</Typography>
            </Box>

            <Box sx={{borderBottom: 1, borderColor: 'divider', mb: 3}}>
                <Tabs
                    value={tab}
                    onChange={(_, value) => setTab(value as TabKey)}
                    aria-label={t('integrations.title')}
                >
                    <Tab
                        value="apiKeys"
                        label={t('apiKeys.menuItem')}
                        icon={<KeyIcon fontSize="small"/>}
                        iconPosition="start"
                    />
                    <Tab
                        value="oidc"
                        label={t('oidcClients.menuItem')}
                        icon={<HubIcon fontSize="small"/>}
                        iconPosition="start"
                    />
                </Tabs>
            </Box>

            {tab === 'apiKeys' && <ApiKeysList/>}
            {tab === 'oidc' && <OidcClients/>}
        </Box>
    );
};

export default ApiKeys;
